import React from 'react'
import TextFilter from '@cloudscape-design/components-themed/text-filter'

// https://cloudscape.design/components/text-filter
export function RadTextFilter ({ ...rest }) {
  return (
    <TextFilter {...rest} />
  )
}
